/*
 * Copyright (c) 2022. American Express Company
 */

import React, { CSSProperties } from 'react';
import { CircleViewModel } from 'src/types/view-models/atoms/circle.view.model';

import styles from './circle.module.scss';

export default function Circle({
    diameter = '72px',
    className,
    style,
    'data-cy': dataCy,
    children
}: CircleViewModel): JSX.Element {
    let allClassNames: string = `${styles.circle}`;
    if (className) allClassNames += ` ${className}`;

    const allStyles: CSSProperties = {
        height: diameter,
        width: diameter,
        minWidth: diameter,
        ...style
    };

    return (
        <div className={allClassNames} style={allStyles} data-cy={dataCy}>
            {children}
        </div>
    );
}
